"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var create_report_controller_1 = __importDefault(require("@components/create-report/create-report.controller"));
require("@services/overrides/360-overrides/services/create-report-360.service");
var angular = __importStar(require("angular"));
var lodash_1 = __importDefault(require("lodash"));
require("./create-report-from-360-template/create-report-from-360-template.component");
var CreateReport360Controller = /** @class */ (function (_super) {
    __extends(CreateReport360Controller, _super);
    function CreateReport360Controller(
    // @ts-ignore
    $scope, 
    // @ts-ignore
    $filter, 
    // @ts-ignore
    $routeParams, 
    // @ts-ignore
    $window, 
    // @ts-ignore
    $location, 
    // @ts-ignore
    viewResults, 
    // @ts-ignore
    createReportService, 
    // @ts-ignore
    globalOption, 
    // @ts-ignore
    userGlobalOptionsService, 
    // @ts-ignore
    API_ROUTES, 
    // @ts-ignore
    qs, 
    // @ts-ignore
    triggerOverrides, 
    // @ts-ignore
    OVERRIDE_EVENTS, 
    // @ts-ignore
    pageLayoutService, 
    // @ts-ignore
    metricsService, 
    // @ts-ignore
    sanitize, 
    // @ts-ignore
    createReport360Service, 
    // @ts-ignore
    prWidgetCountLimitErrorModal, 
    // @ts-ignore
    prWidgetLimitService) {
        var _this = _super.call(this, $scope, $filter, $routeParams, $window, $location, viewResults, createReportService, globalOption, userGlobalOptionsService, API_ROUTES, qs, triggerOverrides, OVERRIDE_EVENTS, pageLayoutService, metricsService, sanitize) || this;
        _this.$scope = $scope;
        _this.$filter = $filter;
        _this.$routeParams = $routeParams;
        _this.$window = $window;
        _this.$location = $location;
        _this.viewResults = viewResults;
        _this.createReportService = createReportService;
        _this.globalOption = globalOption;
        _this.userGlobalOptionsService = userGlobalOptionsService;
        _this.API_ROUTES = API_ROUTES;
        _this.qs = qs;
        _this.triggerOverrides = triggerOverrides;
        _this.OVERRIDE_EVENTS = OVERRIDE_EVENTS;
        _this.pageLayoutService = pageLayoutService;
        _this.metricsService = metricsService;
        _this.sanitize = sanitize;
        _this.createReport360Service = createReport360Service;
        _this.prWidgetCountLimitErrorModal = prWidgetCountLimitErrorModal;
        _this.prWidgetLimitService = prWidgetLimitService;
        return _this;
    }
    CreateReport360Controller.prototype.setupCreateOptions = function () {
        this.CREATE_METHODS = {
            BLANK: 'blank',
            THREE_SIXTY: 'three-sixty',
            IMPORT: 'import'
        };
        this.createOptions = [{
                value: this.CREATE_METHODS.THREE_SIXTY,
                label: this.translate('PR.REPORT_TEMPLATE'),
                icon: 'icon-reportfile-sm'
            }, {
                value: this.CREATE_METHODS.BLANK,
                label: this.translate('PR.BLANK_REPORT'),
                icon: 'icon-blankfile'
            }, {
                value: this.CREATE_METHODS.IMPORT,
                label: this.translate('PR.IMPORT_FROM_QRF'),
                icon: 'icon-xm-upload-large'
            }];
        this.form = {
            createMethod: this.createOptions[0].value,
            reportName: '',
            createFrom: null,
            pages: [] // will be handled by filterable-select-menu component
        };
    };
    CreateReport360Controller.prototype.formComplete = function () {
        if (this.isCreateMethod(this.CREATE_METHODS.BLANK) || this.isCreateMethod(this.CREATE_METHODS.IMPORT)) {
            return _super.prototype.formComplete.call(this);
        }
        else if (this.isCreateMethod(this.CREATE_METHODS.THREE_SIXTY)) {
            var hasReportName = !!lodash_1.default.trim(this.form.reportName);
            return hasReportName && _super.prototype.hasValidPageLayout.call(this);
        }
        throw new Error('Unrecognized Report creation method: ' + this.form.createMethod);
    };
    CreateReport360Controller.prototype.createReport = function () {
        var _this = this;
        // Show in template that a report is being created.
        this.creating = true;
        var sanitizedReportName = this.sanitize.stripHTML(this.form.reportName);
        if (this.form.createMethod === this.CREATE_METHODS.THREE_SIXTY) {
            return this.createReport360Service.getDefaultReportDefinition(this.$routeParams.surveyId, this.form.pageLayout
            // @ts-ignore
            ).then(function (reportDef) {
                var widgetCount = lodash_1.default.sumBy(reportDef.pages, 'widgets.length');
                var widgetCountLimit = _this.getWidgetCountLimit();
                if (widgetCount > widgetCountLimit) {
                    _this.showErrorModal(widgetCountLimit);
                    _this.creating = false;
                    return;
                }
                return _this.createReport360Service.createDefaultReportFromDefinition(sanitizedReportName, _this.form.pageLayout, reportDef
                // @ts-ignore
                ).then(function (report) {
                    _this.viewNewReport(report);
                });
            });
        }
        else if (this.form.createMethod === this.CREATE_METHODS.BLANK) {
            return this.createReport360Service.createEmptyDefaultReport(sanitizedReportName, this.$routeParams.surveyId, this.form.pageLayout
            // @ts-ignore
            ).then(function (report) {
                _this.viewNewReport(report);
            });
        }
        else if (this.form.createMethod === this.CREATE_METHODS.IMPORT) {
            return _super.prototype.createReport.call(this);
        }
        else {
            throw new Error('Unrecognized Report creation method: ' + this.form.createMethod);
        }
    };
    CreateReport360Controller.prototype.getWidgetCountLimit = function () {
        return this.prWidgetLimitService.getWidgetLimit();
    };
    // @ts-ignore
    CreateReport360Controller.prototype.showErrorModal = function (widgetCountLimit) {
        var title = this.translate('PR.REPORT_EXCEEDS_MAX_WIDGETS.TITLE');
        var info = this.translate('PR.REPORT_EXCEEDS_MAX_WIDGETS.CONTENT', { widgetCountLimit: widgetCountLimit });
        this.prWidgetCountLimitErrorModal.show(title, info);
    };
    CreateReport360Controller.$inject = [
        '$scope',
        '$filter',
        '$routeParams',
        '$window',
        '$location',
        'pr.viewResultsProjects',
        'pr.createReport',
        'pr.globalOptionsService',
        'pr.userGlobalOptionsService',
        'pr.API_ROUTES',
        'prQueryString',
        'prOverrideTrigger',
        'pr.OVERRIDE_EVENTS',
        'prPageLayoutService',
        'prMetricsService',
        'prSanitize',
        'pr.createReport360',
        'prWidgetCountLimitWarningModal',
        'prWidgetLimitService'
    ];
    return CreateReport360Controller;
}(create_report_controller_1.default));
exports.default = CreateReport360Controller;
(function (angularModule) {
    angularModule.controller('prCreateReport360Controller', CreateReport360Controller);
})(angular.module('qualtrics.pr'));
